export default __webpack_public_path__ + "static/media/ic_google_play.d50c82e8.svg";